import React, { useCallback } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const FullscreenMessageModal = ({
    title,
    content,
    buttonLabel,
    close = false,
    showModal,
    MODAL_TYPE
}) => {
    // close defaults to just close the modal
    const closeAction = useCallback(close || (() => showModal(MODAL_TYPE.NONE)), [close]);
    return (
        <Dialog
            open
            onClose={closeAction}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAction} variant="contained" color="primary" autoFocus>
                    {buttonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FullscreenMessageModal;
